// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"d1d395f6","726":"cf7d322e"}[chunkId] + ".chunk.js";
};